export default {
  template: `<span>{{ harvested_batch }}</span>`,
  data() {
    return {
      harvested_batch: 'lulu'
    }
  },
  beforeMount() {
    console.log("params_inside");
    console.log(this.params);
  },
  /*
  setup(props) {
      //const displayValue = props.params;
      const displayValue = 'nunu';
      //console.log("props")
      console.log(props.params);
      return {
          displayValue
      }
  }
  */
};